import { Tooltip } from '@systemeio/ui'
import { useRouter } from 'next/router'
import React from 'react'
import { TopMenuSubItem } from 'shared/components/header/components/desktop-menu/components/desktop-menu-item'
import { useLocoTranslation } from 'shared/hooks/use-loco-translation'
import { useShowChangePasswordPage } from 'shared/hooks/use-show-change-password-page'
import useUser from 'shared/hooks/use-user'
import { SubAccountSelector } from './sub-account-selector'
import { ChevronDownIcon } from '@systemeio/ui/icons'

function Avatar() {
  const {
    dashboardUser,
    isWorkspaceOwner,
    isLoading,
    isDisabled,
    isSupportImpersonation,
    shouldShowSubAccountPage,
    avatarUrl,
  } = useUser()

  const { showChangePasswordPage } = useShowChangePasswordPage()
  const { t } = useLocoTranslation()
  const { pathname } = useRouter()

  const isActive = pathname.includes('/profile') || pathname.includes('/subaccounts')

  if (isLoading) {
    return <div className="bg-text-secondary h-10 w-10 animate-pulse rounded-full" />
  }
  if (!dashboardUser) return null
  return (
    <Tooltip
      anchor={{
        gap: -5,
      }}
      stayOnHover={true}
      mode={'hover'}
      popoverClassName={'p-0 rounded-lg shadow-lg'}
      wrapperClassName={'h-[100%]'}
      label={
        <>
          <ul className={'text-text-tertiary flex flex-col py-4 text-sm'}>
            <>
              {!isDisabled && (
                <>
                  <li className={'flex justify-center'}>
                    <SubAccountSelector className={'mx-3 my-1 w-48'} />
                  </li>
                  <li>
                    {isWorkspaceOwner ? (
                      <TopMenuSubItem
                        dataTestId={'settings-link'}
                        name={t('global.settings')}
                        href={'/profile/user-settings'}
                      />
                    ) : (
                      <TopMenuSubItem
                        name={t('global.settings')}
                        href={'/profile/account-settings'}
                      />
                    )}
                  </li>
                  {shouldShowSubAccountPage && (
                    <li>
                      <TopMenuSubItem
                        name={t('header.user.profile.menu.sub_accounts')}
                        href={'/subaccounts'}
                      />
                    </li>
                  )}
                  {/* {showChangePasswordPage && (
                    <li>
                      <TopMenuSubItem
                        name={t('header.user.profile.menu.change_password')}
                        href={'/profile/change-password'}
                      />
                    </li>
                  )} */}
                  <hr className="text-[rgb(var(--background-tertiary))] mx-5 my-1 px-4" />
                </>
              )}
              {isSupportImpersonation && (
                <li>
                  {/*<ExitImpersonateButton>*/}
                  {/*  <p className={AVATAR_MENU_CLASS}>{t('header.exit_impersonation')}</p>*/}
                  {/*</ExitImpersonateButton>*/}
                  <TopMenuSubItem
                    name={t('header.exit_impersonation')}
                    href={`/back/entry?pretend_this_user=_exit`}
                  />
                </li>
              )}
            </>
            <li>
              <TopMenuSubItem name={t('header.user.profile.menu.logout')} href={`/logout`} />
            </li>
          </ul>
        </>
      }
    >
      <div
        className={`focus-visible:border-brand-primary flex h-full items-center gap-2 border-b-4 focus:outline-hidden ${
          isActive ? 'border-brand-primary' : 'border-transparent '
        }`}
      >
        <img
          className="h-10 w-10 overflow-hidden rounded-full object-cover"
          src={avatarUrl}
          alt={`${dashboardUser.firstName} ${dashboardUser.lastName}`}
          data-test-id={'top-menu-avatar'}
        />
        <ChevronDownIcon />
      </div>
    </Tooltip>
  )
}

export default Avatar
